/** Puts "Accept as a new account" beside an invoice's findings about its printed bank account. */
import type { BannerIssue } from '@insio/ui-toolkit';
import { IssueCodes } from '@insio/validation';
import { AcceptInvoiceBankAccountAction } from '../components/AcceptInvoiceBankAccountAction';

/** The findings the printed account can answer: unlike every verified one, or none verified yet. */
const ACCEPTABLE_ACCOUNT_CODES: readonly string[] = [
  IssueCodes.supplierBankAccountMismatch.code,
  IssueCodes.supplierBankAccountNoneVerified.code
];

/** The issues, the bank account findings with the accept action when the reader may add accounts. */
export function withAcceptBankAccountAction(
  issues: BannerIssue[],
  invoiceId: string | undefined,
  supplierPartyId: string | null | undefined,
  canManage: boolean
): BannerIssue[] {
  if (!invoiceId || !canManage) return issues;
  return issues.map(issue =>
    issue.code && ACCEPTABLE_ACCOUNT_CODES.includes(issue.code)
      ? {
          ...issue,
          action: (
            <AcceptInvoiceBankAccountAction
              invoiceId={invoiceId}
              supplierPartyId={supplierPartyId}
            />
          )
        }
      : issue
  );
}
